import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import { useCallback, useMemo } from 'react';
import { consoleWarn } from '../../../system/util/consoleWarn';
import { DEFAULT_MAX_DEPTH_LEVEL } from '../constants';
export var useNavigation = function useNavigation(_ref) {
  var menuItems = _ref.items,
      maxDepthLevel = _ref.maxDepthLevel,
      onElementClick = _ref.onElementClick,
      restRootProps = _objectWithoutProperties(_ref, ["items", "maxDepthLevel", "onElementClick"]);

  var references = useMemo(function () {
    var result = {};

    if (!menuItems) {
      return result;
    }

    var nestingErrorDisplayed = false;

    var traverse = function traverse(items) {
      var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var parentId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var depthLevel = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

      if (!items) {
        return;
      }

      if (depthLevel >= (maxDepthLevel || DEFAULT_MAX_DEPTH_LEVEL)) {
        if (!nestingErrorDisplayed) {
          consoleWarn('Too deep nesting in the SideNavigation.');
        }

        nestingErrorDisplayed = true;
        return;
      }

      for (var i = 0; i < items.length; i += 1) {
        var item = items[i];
        var globalId = "".concat(parentId, ".").concat(item.id);
        result[globalId] = items[i];
        traverse(item.items, path, globalId, depthLevel + 1);
      }
    };

    traverse(menuItems);
    return result;
  }, [menuItems, maxDepthLevel]);
  var onMenuElementClick = useCallback(function (event) {
    var itemNode = event.currentTarget;
    var itemId = itemNode.getAttribute('data-menuelementid');
    var itemGlobalId = itemNode.getAttribute('data-menuelementglobalid');

    if (!itemId || !itemGlobalId) {
      return;
    }

    var itemReference = references[itemGlobalId];

    if (!itemReference) {
      return;
    }

    if (itemReference.menuElementProps && itemReference.menuElementProps.onClick) {
      itemReference.menuElementProps.onClick(event);
    }

    if (event.isPropagationStopped()) {
      return;
    }

    if (onElementClick) {
      onElementClick(itemId, itemReference);
    }
  }, [onElementClick, references]);
  return {
    onMenuElementClick: onMenuElementClick,
    items: menuItems,
    maxDepthLevel: maxDepthLevel,
    restRootProps: restRootProps
  };
};